module.exports = __webpack_public_path__ + "ba8b0a9136ac6edb3318ae5b699b9bed.pdf";